<template>
  <div>
    <BaseTitle :title="$t(!editable ? 'content.user_view' : edit ? 'content.user_edit' : 'content.user_create')" />
    <v-row>
      <v-col cols="12" md="auto" style="width: 330px">
        <v-card>
          <div class="pa-8 mb-4">
            <div v-if="showPhoto">
              <div class="app-section-title">{{ $t('content.user_upload_title') }}</div>
              <image-box
                v-model="form.image"
                :with-upload="editable || form.primarySchoolAdmin"
                :upload-btn-text="$t(edit ? 'change_photo' : 'upload')"
                :image-preview="imageUrl"
                class="mt-4"
              />
            </div>
            <v-btn
              color="primary"
              block
              class="btn-primary-custom"
              v-if="!showPhoto"
              :disabled="form.primarySchoolAdmin || !editable"
              @click="togglePhoto"
            >
              {{ $t('content.add_photo') }}
            </v-btn>
          </div>
        </v-card>
        <v-card>
          <div class="px-8 py-4">
            <form-group :name="$t('table.role')" :validator="$v.form.roleId" no-gutter>
              <template slot-scope="{ attrs }">
                <v-select
                  v-bind="attrs"
                  :items="roleWithoutAdmin"
                  item-value="roleId"
                  :disabled="form.primarySchoolAdmin === true || !editable"
                  item-text="roleName"
                  v-model="form.roleId"
                  @input="$v.form.roleId.$touch()"
                  @blur="$v.form.roleId.$touch()"
                >
                  <template #label>
                    {{ $t('table.role') }}
                    <span class="error--text">*</span>
                  </template>
                  <template #item="{item}">
                    <span v-if="item.roleName == 'School Administrator'">{{ $t('roles.school_administrator') }}</span>
                    <span v-if="item.roleName == 'School Advisor'">{{ $t('roles.school_advisor') }}</span>
                  </template>
                  <template #selection="{item}">
                    <span v-if="item.roleName == 'School Administrator'">{{ $t('roles.school_administrator') }}</span>
                    <span v-if="item.roleName == 'School Advisor'">{{ $t('roles.school_advisor') }}</span>
                  </template>
                </v-select>
              </template>
            </form-group>
          </div>
          <!-- <div class="px-8 py-3" style="background-color:#00BF63; color:#FFFFFF;">
            Role User
          </div>
          <div class="px-8 py-4" style="color:#6D6D6D;">
            <b>{{ roleName }}</b>
          </div> -->
        </v-card>
        <br />
        <v-card>
          <div class="px-8 py-4">
            <form-group :name="$t('form.status')" :validator="$v.form.status" no-gutter>
              <template slot-scope="{ attrs }">
                <v-select :items="status" :disabled="form.primarySchoolAdmin === true || !editable" v-bind="attrs" v-model="form.status" width="100">
                  <template #item="{item}">
                    {{ $t(item.text) }}
                  </template>
                  <template #selection="{item}">
                    {{ $t(item.text) }}
                  </template>
                </v-select>
              </template>
            </form-group>
          </div>
        </v-card>
      </v-col>
      <v-col>
        <form @submit.prevent="submit">
          <v-card class="mb-8">
            <div class="pa-8">
              <div class="app-section-title">
                {{ $t('content.personal_information') }}
              </div>
              <form-group :name="$t('form.first_name')" :validator="$v.form.firstName">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="form.firstName"
                    v-bind="attrs"
                    :disabled="!editable"
                    @input="$v.form.firstName.$touch()"
                    @blur="$v.form.firstName.$touch()"
                  >
                    <template #label>
                      {{ $t('form.first_name') }}
                      <span class="error--text">*</span>
                    </template>
                  </v-text-field>
                </template>
              </form-group>
              <form-group :name="$t('form.last_name')" :validator="$v.form.lastName">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="form.lastName"
                    v-bind="attrs"
                    :disabled="!editable"
                    :label="$t('form.last_name')"
                    @input="$v.form.lastName.$touch()"
                    @blur="$v.form.lastName.$touch()"
                  >
                  </v-text-field>
                </template>
              </form-group>
              <form-group :name="$t('form.gender')" :validator="$v.form.gender">
                <template slot-scope="{ attrs }">
                  <v-select :items="gender" :disabled="!editable" v-bind="attrs" v-model="form.gender">
                    <template #label>
                      {{ $t('form.gender') }}
                      <span class="error--text">*</span>
                    </template>
                    <template #item="{item}">
                      {{ $t(item.text) }}
                    </template>
                    <template #selection="{item}">
                      {{ $t(item.text) }}
                    </template>
                  </v-select>
                </template>
              </form-group>
              <form-group :name="$t('form.place_of_birth')" :validator="$v.form.placeOfBirth">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="form.placeOfBirth"
                    v-bind="attrs"
                    :disabled="!editable"
                    @input="$v.form.placeOfBirth.$touch()"
                    @blur="$v.form.placeOfBirth.$touch()"
                  >
                    <template #label>
                      {{ $t('form.place_of_birth') }}
                      <span class="error--text">*</span>
                    </template>
                  </v-text-field>
                </template>
              </form-group>
              <form-group v-slot="{ attrs, on }" :name="$t('form.date_of_birth')" :validator="$v.form.dateOfBirth">
                <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
                    <v-text-field
                      v-model="form.dateOfBirth"
                      :disabled="!editable"
                      readonly
                      v-bind="{ ...attrs, ...menuAttrs }"
                      v-on="{ ...on, ...menuOn }"
                      @blur="$v.form.dateOfBirth.$touch()"
                    >
                      <template #label>
                        {{ $t('form.date_of_birth') }}
                        <span class="error--text">*</span>
                      </template>
                      <template #append> <svg-icon icon="calendar" class="primary--text mr-3" /> </template>
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="form.dateOfBirth" :active-picker.sync="activePicker" :max="datemaxcurrent" :locale="$i18n.locale">
                    <template #label>
                      {{ $t('form.date_of_birth') }}
                      <span class="error--text">*</span>
                    </template>
                  </v-date-picker>
                </v-menu>
              </form-group>
              <form-group :name="$t('form.email')" :validator="$v.form.email">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="form.email"
                    v-bind="attrs"
                    :disabled="form.primarySchoolAdmin === true || !editable"
                    @input="$v.form.email.$touch()"
                    @blur="$v.form.email.$touch()"
                  >
                    <template #label>
                      {{ $t('form.email') }}
                      <span class="error--text">*</span>
                    </template>
                  </v-text-field>
                </template>
              </form-group>
              <form-group :name="$t('form.phone_number')" :validator="$v.form.phoneNumber">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="form.phoneNumber"
                    v-bind="attrs"
                    v-phone
                    :disabled="!editable"
                    @input="$v.form.phoneNumber.$touch()"
                    @blur="$v.form.phoneNumber.$touch()"
                  >
                    <template #label>
                      {{ $t('form.phone_number') }}
                      <span class="error--text">*</span>
                    </template>
                  </v-text-field>
                </template>
              </form-group>
              <form-group :name="$t('form.position')" :validator="$v.form.positionName">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="form.positionName"
                    v-bind="attrs"
                    :disabled="!editable"
                    @input="$v.form.positionName.$touch()"
                    @blur="$v.form.positionName.$touch()"
                  >
                    <template #label>
                      {{ $t('form.position') }}
                      <span class="error--text">*</span>
                    </template>
                  </v-text-field>
                </template>
              </form-group>

              <div class="app-section-title">{{ $t('content.address_information') }}</div>
              <form-group :name="$t('form.address')" :validator="$v.form.address">
                <template slot-scope="{ attrs }">
                  <v-textarea
                    v-model="form.address"
                    v-bind="attrs"
                    :disabled="!editable"
                    @input="$v.form.address.$touch()"
                    @blur="$v.form.address.$touch()"
                  >
                    <template #label>
                      {{ $t('form.address') }}
                      <span class="error--text">*</span>
                    </template>
                  </v-textarea>
                </template>
              </form-group>
              <form-group :name="$t('form.province')" :validator="$v.form.provinceId">
                <template slot-scope="{ attrs }">
                  <v-autocomplete
                    :items="provinces"
                    :loading="loadingProvinces"
                    :disabled="!editable"
                    item-value="provinceId"
                    item-text="name"
                    v-bind="attrs"
                    v-model="form.provinceId"
                    @change="getCities"
                  >
                    <template #label>
                      {{ $t('form.province') }}
                      <span class="error--text">*</span>
                    </template>
                  </v-autocomplete>
                </template>
              </form-group>
              <form-group :name="$t('form.city')" :validator="$v.form.cityId">
                <template slot-scope="{ attrs }">
                  <v-autocomplete
                    :items="cities"
                    :loading="loadingCities"
                    :disabled="!editable"
                    item-value="cityId"
                    item-text="name"
                    v-bind="attrs"
                    v-model="form.cityId"
                  >
                    <template #label>
                      {{ $t('form.city') }}
                      <span class="error--text">*</span>
                    </template>
                  </v-autocomplete>
                </template>
              </form-group>
              <form-group :name="$t('form.postal_code')" :validator="$v.form.postalCode">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    minlength="5"
                    maxlength="5"
                    v-model.number="form.postalCode"
                    v-bind="attrs"
                    v-number
                    :label="$t('form.postal_code')"
                    :disabled="!editable"
                    @input="$v.form.postalCode.$touch()"
                    @blur="$v.form.postalCode.$touch()"
                  />
                </template>
              </form-group>
            </div>
          </v-card>
          <div class="d-flex justify-end align-center">
            <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="backToList">{{ $t(edit ? 'back' : 'cancel') }}</v-btn>
            <v-btn v-if="editable" color="primary" :loading="loading" class="btn-primary-custom" type="submit">{{
              $t(edit ? 'save' : 'submit')
            }}</v-btn>
          </div>
        </form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { required, email, numeric, maxLength } from 'vuelidate/lib/validators';
import phoneNumber from '@/validators/phoneNumber';
import onlyWord from '@/validators/onlyWord';
import { fileSize, alphaSpace } from '@/validators';
import BaseTitle from '@/components/base/Title';
import ImageBox from '@/components/ImageBox';
export default {
  name: 'MasterUserCreateEdit',
  props: {
    editable: {
      type: Boolean,
      default: true
    }
  },
  components: {
    BaseTitle,
    ImageBox
  },
  computed: {
    ...mapGetters({
      status: 'Reference/itemStatus',
      provinces: 'Reference/itemProvinces',
      gender: 'Reference/itemGender',
      role: 'Role/items'
    }),
    cities: {
      get() {
        return this.$store.getters['Reference/itemCities']();
      }
    },
    roleName() {
      let roleName = {
        1: 'Master Administrator',
        2: 'School Administrator',
        3: 'Parents',
        4: 'Teacher',
        5: 'Student',
        6: 'School Advisor'
      };
      return roleName?.[this.form.roleId];
    },
    roleWithoutAdmin() {
      return this.role.filter(role => role.roleId !== 1 && role.roleId !== 3 && role.roleId !== 4 && role.roleId !== 5);
    }
  },
  validations: function() {
    return {
      form: {
        image: { fileSize: fileSize(1) },
        firstName: { required, alphaSpace, maxLength: maxLength(50) },
        lastName: { alphaSpace, maxLength: maxLength(50) },
        phoneNumber: { required, phone: phoneNumber, maxLength: maxLength(15) },
        email: {
          required,
          email,
          [this.validationName](value) {
            if (!value) return true;
            return new Promise(resolve => {
              this.axios
                .get('api/user/validate-email', {
                  params: {
                    email: value,
                    roleId: this.form.roleId,
                    userId: this.initialData?.userId || this.$route.params?.id || null
                  }
                })
                .then(() => resolve(true))
                .catch(err => {
                  const code = err?.response?.data?.errorMessages;
                  const errorCode = ['isRegistered', 'isRegisteredInactive', 'isRegisteredInAnotherRole'];
                  this.validationName = errorCode?.[code - 1];
                  resolve(false);
                });
            });
          }
        },
        gender: { required },
        address: { required, maxAddressLength: maxLength(255) },
        placeOfBirth: { required, alphaSpace },
        dateOfBirth: {
          required,
          date: function(value) {
            return this.datemaxcurrent ? value <= this.datemaxcurrent : true;
          }
        },
        status: { required },
        roleId: { required },
        provinceId: { required },
        cityId: { required },
        positionName: { required, onlyWord, maxLength: maxLength(50) },
        postalCode: { numeric, maxLength: maxLength(5) }
      }
    };
  },
  data: () => ({
    form: {
      firstName: '',
      lastName: '',
      phoneNumber: '',
      email: '',
      gender: '',
      address: '',
      status: true,
      placeOfBirth: '',
      provinceId: null,
      dateOfBirth: '',
      cityId: '',
      postalCode: '',
      positionName: '',
      roleId: '',
      image: null,
      primarySchoolAdmin: ''
    },
    edit: false,
    showPhoto: false,
    validationName: 'dynamic',
    imageUrl: null,
    menu: false,
    loading: false,
    hasLoad: false,
    loadingProvinces: false,
    loadingCities: false,
    datemaxcurrent: (() => {
      const d = new Date();
      d.setFullYear(d.getFullYear() - 17);
      return d.toISOString().split('T')[0];
    })(),
    activePicker: null
  }),
  methods: {
    getData() {
      this.$store.dispatch('Userschool/fetchDetail', this.$route.params.id).then(res => {
        // Object.keys(this.form).forEach(form => (this.form[form] = res[form]));
        Object.keys(this.form).forEach(form => {
          this.form[form] = res[form];
        });
        this.form.image = null;
        if (res.imageUrl) {
          this.imageUrl = res.imageUrl;
          this.showPhoto = true;
        }
        this.getCities();
        this.hasLoad = true;
      });
    },
    getProvinces() {
      this.loadingProvinces = true;
      this.$store.dispatch('Reference/fetchProvinces').finally(() => (this.loadingProvinces = false));
    },
    getCities() {
      if (this.hasLoad) {
        this.form.cityId = null;
      }
      this.loadingCities = true;
      this.$store.dispatch('Reference/fetchCities', this.form.provinceId).finally(() => (this.loadingCities = false));
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }

      this.loading = true;
      const payload = { ...(this.edit ? { id: this.$route.params.id } : null), ...this.form };
      this.$store
        .dispatch(`Userschool/${this.edit ? 'update' : 'save'}`, payload)
        .then(() => this.$router.push({ name: this.edit ? 'UserSchoolUpdateSuccess' : 'UserSchoolSuccess' }))
        .finally(() => (this.loading = false));
    },
    backToList() {
      this.$router.push({ name: 'MasterUserSchool' });
    },
    preventNav(event) {
      if (!this.edit || !this.$v.$anyDirty) return;
      event.preventDefault();
      event.returnValue = '';
    },
    togglePhoto() {
      this.showPhoto = !this.showPhoto;
    },
    getRole() {
      this.$store.dispatch('Role/fetchList');
    }
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'));
    }
  },
  created() {
    this.$store.commit('Reference/RESET_CITIES');
    this.getProvinces();
    this.getRole();

    if (this.$route.params.id) {
      this.edit = true;
      this.getData();
    } else {
      this.hasLoad = true;
    }
  },
  beforeMount() {
    window.addEventListener('beforeunload', this.preventNav);
    this.$once('hook:beforeDestroy', () => window.removeEventListener('beforeunload', this.preventNav));
  },
  beforeRouteLeave(to, from, next) {
    if (!this.edit && this.$v.$anyDirty && this.$v.$invalid) {
      if (!window.confirm(this.$t('alert.leave_message'))) {
        return;
      }
    }
    next();
  }
};
</script>
